import '../App.css';
import '../styles/about.css';
import logo from '../chad_no_background.png';
import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';

// Tutorial for Making Navbar Component: https://www.youtube.com/watch?v=fL8cFqhTHwA
// Font Icons: https://fontawesome.com/
// Use npm start to start site
// npm run build to build site for deployment 

class About extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    }

  }

  render() {

    return (
      <div className="App">

        <Navbar />

        <header className="App-header">

          <img src={logo} /*className="App-logo"*/ alt="logo" />

          <p>
          <br></br>
          - Keep track of your gym stats, and share with your friends!<br></br><br></br>
          - Able to log your stats; bench, squat, deadlift, and body weight.<br></br><br></br>
          - When you log each stat, it will be updated to your "stats card".<br></br><br></br>
          - Additionally, you can set your favorite gym playlist, gym idol, and your own profile picture on your stats card.


            <br></br>
            {/*Supports Youtube, Spotify, and Apple Music. And supports slash commands.*/}
            <br></br>
            <br></br>
            {/*For the Spotify users: After logging in using the Spotify login command, you will be able to access and play your Spotify playlists, apply your favorite music genre that you listen to on Spotify as a role, play your Spotify top tracks, and can logout at anytime.*/}              
            <br></br>
            <br></br>
            <a href="/commandsList">Click here for a list of the commands</a>
            <br></br>
            <br></br>
          </p>

        </header>

        <Footer />

      </div>
    );
  }

}

export default About;